import React from 'react';

// Interface for field data
interface FieldData {
  label: string;
  value: string;
}

interface PanelReturnTextBoxProps {
  fields: FieldData[];
}

// Icon components
const TimeIcon: React.FC = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="field-icon">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" 
      stroke="#2196f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 6V12L16 14" stroke="#2196f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const OreIcon: React.FC = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="field-icon">
    <path d="M21 4H3L10 12.46V19L14 21V12.46L21 4Z" 
      stroke="#2196f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ShipIcon: React.FC = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="field-icon">
    <path d="M2 22L12 2L22 22H2Z" stroke="#2196f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 17L7 22H17L12 17Z" stroke="#2196f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Get appropriate icon based on label
const getIconForField = (label: string): React.ReactNode => {
  const lowerLabel = label.toLowerCase();
  if (lowerLabel.includes('time')) {
    return <TimeIcon />;
  } else if (lowerLabel.includes('ore')) {
    return <OreIcon />;
  } else if (lowerLabel.includes('trip')) {
    return <ShipIcon />;
  }
  return null;
};

const PanelReturnTextBox: React.FC<PanelReturnTextBoxProps> = ({ fields = [] }) => {
  return (
    <div className="panel-return-text-box">
      <div className="return-content panel-return-text-content">
        {fields.map((field, index) => (
          <div key={`field-${index}`} className="return-field">
            <div className="return-field-header">
              <span className="return-label">{getIconForField(field.label)} {field.label}</span>
            </div>
            <div className="return-value">
              {field.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PanelReturnTextBox;
